import { d as defineCustomElement } from '../chunks/vidstack-B11i_cNc.js';
import { a as MediaPlayerElement, M as MediaProviderElement } from '../chunks/vidstack-CMs77pq9.js';
import '../chunks/vidstack-D9mrLNU5.js';
import '../chunks/vidstack-CG48l7du.js';
import '../chunks/vidstack-VrKElWm_.js';
import '../chunks/vidstack-BnqIpPdq.js';
import '../chunks/vidstack-DMdWO-lC.js';
import '../chunks/vidstack-CzvK2UwB.js';
import '../chunks/vidstack-COCzjeeM.js';
import '../chunks/vidstack-CUVgUi9M.js';
import '../chunks/vidstack-BSXZsAhp.js';
import '../chunks/vidstack-DM_McBs5.js';
import '../chunks/vidstack-ksPACRiU.js';

defineCustomElement(MediaPlayerElement);
defineCustomElement(MediaProviderElement);
